<script lang="ts" setup>
import type { NavigationMenuItem } from '@nuxt/ui'

defineProps<{
  links: NavigationMenuItem[]
}>()
</script>

<template>
  <UHeader
    :ui="{
      root: 'bg-transparent border-none',
      container: 'max-w-full',
      center: 'w-3/5 xl:w-8/12',
      left: 'max-w-22',
      right: 'gap-6',
      content: 'bg-gradient-to-b from-wine-800/60 via-wine-900/40 border-none',
      overlay: 'bg-gradient-to-b from-wine-950/60 via-wine-950/40 to-transparent'
    }"
  >
    <template #left>
      <span>LOGO</span>
    </template>

    <template #default>
      <LazyUContentSearchButton
        size="xl"
        variant="solid"
        :collapsed="false"
        :kbds="['meta', 'k']"
        :fuse="{ resultLimit: 42 }"
        :ui="{
          base: 'w-4/4 h-14 bg-slate-400/20 rounded-full active:bg-slate-400/30 hover:bg-slate-400/30',
          trailing: 'opacity-70',
          label: 'text-slate-300',
          leadingIcon: 'text-slate-100'
        }"
      />
    </template>

    <template #right>
      <UIcon
        name="i-lucide-bell"
        class="size-7"
      />

      <UIcon
        name="i-lucide-shopping-cart"
        class="size-7"
      />

      <UUser
        name="Raul S. Araujo"
        size="2xl"
        :avatar="{
          src: 'https://github.com/shadcn.png',
          icon: 'i-lucide-user'
        }"
        :ui="{
          root: 'hidden md:flex',
          name: 'text-slate-100'
        }"
      >
        <template #description>
          <UButton
            size="sm"
            variant="link"
            color="primary"
            class="p-0"
          >
            View profile
          </UButton>
        </template>

        <template #body>
          <UNavigationMenu
            variant="link"
            :items="links"
            :ui="{
              link: 'text-red-400',
              linkLeadingIcon: 'text-red-400'
            }"
          />
        </template>
      </uuser>
    </template>
  </UHeader>
</template>
